export default "__VITE_IMAGE_ASSET__a9fb1117__";